import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * Displays a card representing a package with title, count, optional image and styling.
 * @component
 * @selector app-package-cards
 * @example
 *   <app-package-cards
 *     [title]="'Premium Plan'"
 *     [count]="'12'"
 *     [cardClass]="'featured'"
 *     [image]="'/assets/package.png'">
 *   </app-package-cards>
 * @input {string} title - The main title text shown on the package card.
 * @input {string} count - A supplementary count or badge text associated with the package.
 * @input {string} cardClass - Optional CSS class(es) applied to the card root for styling variations.
 * @input {string} image - Optional image URL displayed in the card (e.g., thumbnail or icon).
 * @output {none} none - This component does not emit any output events; it is presentational only.
 * Key methods: None — the component is a simple presentational component without public methods.
 * Lifecycle hooks: Uses Angular defaults; no custom lifecycle hooks are implemented.
 */
@Component({
  selector: 'app-package-cards',
  standalone: true,
  imports: [NgClass],
  templateUrl: './package-cards.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './package-cards.component.scss',
})
export class PackageCardsComponent {
  @Input() title = '';
  @Input() count = '';
  @Input() cardClass = '';
  @Input() image = '';
}
